import { render, staticRenderFns } from "./DeliveryDates.vue?vue&type=template&id=edd5cb6a"
import script from "./DeliveryDates.vue?vue&type=script&lang=js"
export * from "./DeliveryDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports